import {ISymbol} from "../../core/reel/IReelData";
import {gsap, TimelineLite} from "gsap";
import {PearlHarbor} from "../PearlHarbor";
import {PearlHarborGameAssets} from "../PearlHarborGameAssets";
import {SpineTween} from "@nolimitcity/slot-game/bin/animation/SpineTween";
import {PearlHarborSoundManager} from "../sound/PearlHarborSoundManager";
import {PearlHarborGameConfig} from "../PearlHarborGameConfig";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {ISymbolData} from "../server/PearlHarborModel";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {PearlHarborGameMode} from "../server/PearlHarborGameMode";

export enum PearlHarborSymbolStates {
    NORMAL,
    WIN,
    NO_WIN,
    LANDING
}

export enum SYMBOL_NAME {
    SCATTER = "BN",
    SCATTER_H = "BN_H",
    M1 = "M1",
    M2 = "M2",
    M3 = "M3",
    M4 = "M4",
    M5 = "M5",
    L1 = "L1",
    L2 = "L2",
    L3 = "L3",
    L4 = "41",
    L5 = "L5",
    EMPTY = "X",
    XS = "X_SPLIT",
    XS_H = "X_SPLIT_H",
    SPLIT_SPENT = "X_SPLIT_SPENT",
    SPLIT_SPENT_H = "X_SPLIT_SPENT_H",
    BOMB = "X_BOMB",
    BOMB_H = "X_BOMB_H",
    TARGET = "TARGET",
    TARGET_H = "TARGET_H",
    TARGET_SPENT = "TARGET_SPENT",
    TARGET_SPENT_H = "TARGET_SPENT_H"
}

export class PearlHarborSymbol extends PIXI.Container implements ISymbol {
    protected _name: string;
    protected _textureName: string;
    private readonly MULTIPLIER_STYLE: PIXI.TextStyle = new PIXI.TextStyle({
        fontWeight: FontWeight.BOLD,
        fontFamily: "Arial",
        align: "center",
        fill: "#FFFFFF",
        fontSize: 48,
        stroke: 0x000000,
        strokeThickness: 8,
        wordWrap: true,
        wordWrapWidth: 500,
        dropShadow: true,
        dropShadowAngle: 8,
        dropShadowBlur: 4,
        dropShadowDistance: 4
    });
    protected _reelPosition: number;
    protected _onReelId: number;
    protected _reelTargetPosition: number;
    protected _reelId: number;
    protected _isRemoved: boolean;
    private _collapseYPos: number;
    private _isBig: boolean = false;
    protected _isSplit: boolean;
    private _isActivated: boolean;
    private _symWidth: number;
    private _symHeight: number;
    protected _sizeMultiplier: PIXI.Text;
    private _bigMultiplier: PIXI.Text;
    private _sizeMultiValue: number;
    private _bigMultiValue: number;
    private _topLeftSeed: number;
    private _symSize: number[];
    protected _idleAnimation: PIXI.spine.Spine;
    protected _newStateSprite: PIXI.Sprite;
    protected _currentStateSprite: PIXI.Sprite;
    public state: PearlHarborSymbolStates;

    public get isWild():boolean {
        return this._name.includes("SPLIT") || this._name.includes("BOMB") || this._name.includes("TARGET");
    }

    constructor(symbolData: ISymbolData) {
        super();
        this.isRemoved = false;
        const symbolName: string = symbolData.symName;
        this._name = symbolName;
        this._textureName = symbolData.textureName;
        if (symbolName == undefined) {
            debugger;
        }

        this._currentStateSprite = new PIXI.Sprite();
        this._currentStateSprite.name = "currentStateSprite";
        this._currentStateSprite.position.set(0, 0);
        this._currentStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite = new PIXI.Sprite();
        this._newStateSprite.name = "newStateSprite";
        this._newStateSprite.position.set(0, 0);
        this._newStateSprite.anchor.set(0.5, 0.5);
        this._newStateSprite.alpha = 0;

        this._isSplit = symbolData.isSplit;
        this._isBig = symbolData.isBig;
        this._topLeftSeed = symbolData.topLeftSeed;
        this._collapseYPos = symbolData.collapseY;
        this._symSize = symbolData.size;

        this._sizeMultiValue = symbolData.sizeMultiplier;
        this._bigMultiValue = symbolData.sizeMultiplier;

        this._symWidth = PearlHarborGameConfig.symbolWidth * symbolData.size[0];
        this._symHeight = PearlHarborGameConfig.symbolHeight * symbolData.size[1];

        this._sizeMultiplier = new PIXI.Text("", this.MULTIPLIER_STYLE);
        this._sizeMultiplier.visible = false;
        this._sizeMultiplier.name = "sizeMultiplier";

        this._bigMultiplier = new PIXI.Text("", this.MULTIPLIER_STYLE);
        this._bigMultiplier.visible = false;
        this._bigMultiplier.name = "bigMultiplier";

        if (this._isBig) {
            this._currentStateSprite.position.set(-PearlHarborGameConfig.symbolWidth * 0.5, -PearlHarborGameConfig.symbolHeight * 0.5);
            this._newStateSprite.position.set(-PearlHarborGameConfig.symbolWidth * 0.5, -PearlHarborGameConfig.symbolHeight * 0.5);
            this._currentStateSprite.anchor.set(0, 0);
            this._newStateSprite.anchor.set(0, 0);
            this.bigMultiplier = symbolData.bigMultiplier;
            this.visible = (this._textureName.slice(-1) === "0");
        }

        this.addChild(this._newStateSprite);
        this.addChild(this._currentStateSprite);
        this.addChild(this._sizeMultiplier);
        this._currentStateSprite.addChild(this._bigMultiplier);
        this._sizeMultiplier.anchor.set(1);
        this._sizeMultiplier.position.set(this._symWidth*0.5+9, this._symHeight*0.5+9);
        this._bigMultiplier.anchor.set(1);
        this._bigMultiplier.position.set(this._symWidth, this._symHeight);
    }

    protected setState(state: PearlHarborSymbolStates, textureName: string, changeSpeed: number = 0): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.state = state

            if (textureName == "none") {
                this._newStateSprite.texture = PIXI.Texture.EMPTY;
            } else {
                this._currentStateSprite.texture = PIXI.Texture.EMPTY;
                if (this.symbolName === "X" || this.symbolName === "X_H") {
                    this._newStateSprite.texture = PIXI.Texture.EMPTY;
                } else {
                    this._newStateSprite.texture = PearlHarbor.assetLoader.getTextures(PearlHarborGameAssets.getSymbolStateTexturePath(this._textureName, textureName))[0];
                }
                this._newStateSprite.alpha = 1;
            }
            this._currentStateSprite.texture = this._newStateSprite.texture
            this._currentStateSprite.alpha = 1
            this._newStateSprite.alpha = 0
        }, 0.001);

        return tl;
    }

    public init(initState: PearlHarborSymbolStates): PearlHarborSymbol {
        this.getStateAnimation(initState);
        return this;
    }

    public getStateAnimation(state: PearlHarborSymbolStates, changeSpeed: number = 0): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (this.state == state) {
            return tl;
        }


        switch (state) {
            case PearlHarborSymbolStates.NORMAL:
                tl.add(this.setState(state, ""));
                break;
            case PearlHarborSymbolStates.NO_WIN:
                tl.add(gsap.to(this, {
                    duration: 0.3,
                    pixi: {alpha: 1, saturation: 0, combineCMF: false, brightness: 0}
                }));
                break;
            default:

        }

        if (tl.duration() == 0) {
            tl.add(gsap.to(this, {duration: 0.0001}));
        }

        return tl;
    }

    public remove() {
        this.destroy({children : true});
    }

    public playOutsideIdleAnim(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (PearlHarbor.model.data.wasFeatureBuy) {
            return tl;
        }

        if (PearlHarbor.model.data.nextMode === PearlHarborGameMode.NORMAL) {
            this.removeIdleAnimation();
            return tl;
        }

        if (!this._idleAnimation) {
            this._idleAnimation = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset(`x_bomb${this._isSplit ? "_h" : ""}`));
            this.addChild(this._idleAnimation);
            this._idleAnimation.position.set(0, 0);

            tl.add([
                () => {
                    PearlHarborSoundManager.playBombLandingSound();
                    this.currentStateSprite.visible = false;
                },
                new SpineTween(this._idleAnimation, 0, `land`)
            ])

            if (PearlHarbor.model.data.nextMode === PearlHarborGameMode.NORMAL_AVALANCHE) {
                tl.add(()=>{
                    if(this._idleAnimation && this._idleAnimation.state){
                        this._idleAnimation.state.setAnimation( 1, `idle_outside`, true);
                    }
                });
            }
        }

        return tl;
    }

    public removeIdleAnimation(): void {
        if (this.symbolName.indexOf("bomb") < -1) {
            return;
        }
        this.currentStateSprite.visible = true;
        if (this._idleAnimation) {
            this._idleAnimation.state.setEmptyAnimation(0,0);
            this.removeChild(this._idleAnimation);
        }
    }

    //XS TO WILD
    public playToWildAnim(withAnimation: boolean = true): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        this._name = `X_SPLIT_SPENT${this._isSplit ? "_H" : ""}`;
        this._textureName = `X_SPLIT_SPENT${this._isSplit ? "_H" : ""}`;
        if (withAnimation) {
            const spineObj: PIXI.spine.Spine = new PIXI.spine.Spine(PearlHarbor.assetLoader.getSpineAsset("XS"));
            this.addChild(spineObj);
            spineObj.position.set(0, 0);
            tl.add([new SpineTween(spineObj, 0, `turn_wild`)]);
            tl.add(() => {
                this.removeChild(spineObj);
            });
        }
        tl.add(() => {
            this.currentStateSprite.texture = PearlHarbor.assetLoader.getTextures(`${this._textureName}/${this._textureName}`)[0];
            this.updateMultiplier();
        });
        return tl;
    }

    public updateMultiplier(id?: number): TimelineLite {
        this.sizeMultiplier = PearlHarbor.model.allSizesBeforeCollapse[this._reelId][id ? id : this._onReelId];
        return new TimelineLite();
    }

    public checkMultiplier(): void {
        //to verify
        const serverMulti: number = PearlHarbor.model.allSizesBeforeCollapse[this._reelId][this._onReelId];
        if (this._sizeMultiValue != serverMulti) {
            Logger.logDev(`<---- not correct multiplier ----> ${this.symbolName} is ${this._sizeMultiValue} not ${serverMulti} at [${this.reelId},${this.onReelId}]`);
        }
    }

    public fallOut(): void {
    }

    public get reelId(): number {
        return this._reelId;
    }

    public set reelId(value: number) {
        this._reelId = value;
    }

    public get onReelId(): number {
        return this._onReelId;
    }

    public set onReelId(value: number) {
        this._onReelId = value;
    }

    public get symbolName(): string {
        return this._name;
    }

    public set symbolName(value: string) {
        this._name = value;
    }

    public get isSplit(): boolean {
        return this._isSplit;
    }

    public set isSplit(value: boolean) {
        this._isSplit = value;
    }

    public get isActivated(): boolean {
        return this._isActivated;
    }

    public set isActivated(value: boolean) {
        this._isActivated = value;
    }

    public get reelPosition(): number {
        return this._reelPosition;
    }

    public set reelPosition(value: number) {
        this._reelPosition = value;
    }

    public get reelTargetPosition(): number {
        return this._reelTargetPosition;
    }

    public set reelTargetPosition(value: number) {
        this._reelTargetPosition = value;
    }

    public get isRemoved(): boolean {
        return this._isRemoved;
    }

    public set isRemoved(value: boolean) {
        this._isRemoved = value;
    }

    public get isBig(): boolean {
        return this._isBig;
    }

    public set isBig(value: boolean) {
        this._isBig = value;
    }

    public get collapseYPos(): number {
        return this._collapseYPos;
    }

    public set collapseYPos(value: number) {
        this._collapseYPos = value;
    }

    public get sizeMultiplier(): number {
        return this._sizeMultiValue;
    }

    public get bigMultiplier(): number {
        return this._bigMultiValue;
    }

    public set sizeMultiplier(value: number) {
        if(value === undefined){
            return;
        }
        this._sizeMultiValue = value;
        this._sizeMultiplier.text = "x" + value.toString();
        this._sizeMultiplier.visible = (value > 1);
        this.addChild(this._sizeMultiplier);
    }

    public set bigMultiplier(value: number) {
        this._bigMultiValue = value;
        this._bigMultiplier.text = "x" + value.toString();
        this._bigMultiplier.visible = value > 1;
    }

    public get currentStateSprite(): PIXI.Sprite {
        return this._currentStateSprite;
    }

    public get symHeight(): number {
        return this._symHeight;
    }

    public get topLeftSeed(): number {
        return this._topLeftSeed;
    }

    public set topLeftSeed(value:number) {
        this._topLeftSeed = value;
    }

    public get symSize(): number[] {
        return this._symSize;
    }

    public get textureName(): string {
        return this._textureName;
    }
}